import store from "@/store";

export default async (to, from, next) => {
  if (store.getters["auth/check"]) {
    return next(from.path);
  }

  return next();
};
